export const isDefaultAvatarUrl = (url?: string) =>
  !url || url.endsWith('/avatars/original/missing.png');

export const getAvatarInitial = (acct?: string) =>
  acct ? acct.charAt(0).toUpperCase() : '';
